export const referralPage = {
  seo: {
    title: "Akinda Referral Program — Earn with Your Referral Link",
    description:
      "Share your Akinda referral link. You earn 15% when they subscribe. New users will get 10% off later.",
    keywords:
      "akinda referral, referral link, subscription referral, earn with akinda, refer friends",
    ogTitle: "Akinda Referral Program — Earn with Your Referral Link",
    ogDescription:
      "Invite others with your referral link. You earn 15% when they subscribe. New-user 10% off is coming later.",
  },
  hero: {
    badge: "Akinda Referral Program",
    title: "Share Akinda.",
    titleAccent: "Earn Rewards.",
    leadBefore: "Invite others to Akinda. When they subscribe through your referral link,",
    leadAccent: "you earn.",
    apply: "Apply",
    promoLabel: "Your referral link",
    promoHint: "Share. They subscribe. You earn.",
    earningsLabel: "Per referred client",
    earningsHint: "{{percent}}% of {{amount}}",
    steps: {
      share: {
        title: "Share your link",
        description: "Send your personal referral link to friends.",
      },
      subscribe: {
        title: "They Subscribe",
        description: "They buy any Akinda subscription.",
      },
      earn: {
        title: "You Earn",
        description: "You earn rewards for every successful purchase.",
      },
    },
  },
  how: {
    label: "How it works",
    title: "Earn when someone subscribes through your link",
    lead: "Share your personal referral link. New users will get {{clientPercent}}% off (coming later), and you earn {{referrerPercent}}% when they buy a subscription.",
    highlights: {
      client: {
        title: "Client discount",
        description:
          "New users will get {{percent}}% off their subscription. This discount is coming later.",
        value: "{{percent}}%",
      },
      referrer: {
        title: "Your reward",
        description:
          "You earn {{percent}}% when someone buys a subscription using your referral.",
        value: "{{percent}}%",
      },
      link: {
        title: "Your referral link",
        description:
          "Send your personal link. Someone is attributed to you when they create an account through it.",
        value: "Link",
      },
    },
  },
  calc: {
    label: "Earnings calculator",
    title: "Estimate your monthly potential",
    lead: "Drag the slider to set referred clients. Revenue assumes a {{subscription}} subscription and your {{percent}}% reward ({{perClient}} per client).",
    revenueLabel: "Monthly potential revenue",
    revenueHint:
      "Based on {{count}} referred clients × {{subscription}} × {{percent}}%",
    clientsLabel: "Referred clients",
    clientsAria: "Number of referred clients",
    meta: "Adjust how many paying subscribers join through your referral link. Example only — actual rewards depend on plan price and successful checkouts.",
    steps: {
      share: {
        title: "Share your link",
        description: "Send your personal referral link to friends and your audience.",
      },
      subscribe: {
        title: "They subscribe",
        description: "They buy any Akinda subscription after joining through your link.",
      },
      earn: {
        title: "You earn",
        description: "You receive {{percent}}% commission for every successful purchase.",
      },
    },
  },
  apply: {
    label: "Apply",
    title: "Join the referral program",
    lead: "Tell us who you are and where you share Akinda. We’ll reply at the contact you provide.",
    formTitle: "Referral application",
    formLead:
      "Submitting opens your email client with a message to {{email}}. Review and send to complete your request.",
    name: "Name",
    contact: "Contact",
    contactHint: "(email or phone)",
    about: "About yourself",
    aboutPlaceholder:
      "Who are you, who do you reach, and why do you want to refer Akinda?",
    social: "Social media",
    socialPlaceholder:
      "Links or handles (Instagram, LinkedIn, Telegram, X, YouTube, etc.)",
    submit: "Email application",
    orWrite: "Or write us directly at",
    errors: {
      name: "Please enter your name.",
      contact: "Please enter a valid email or phone number.",
      about: "Please tell us a bit more about yourself.",
      social: "Please share at least one social media profile or handle.",
    },
  },
  note: {
    ariaLabel: "Program note",
    body: "Rewards follow your referral link. A new user counts when they register through it. Applications are reviewed case by case. Questions?",
  },
  mailto: {
    subject: "Referral program application — {{name}}",
    greeting: "Hi Akinda team,",
    intro: "I'd like to apply for the Akinda Referral Program.",
    name: "Name",
    contact: "Contact",
    about: "About me:",
    social: "Social media:",
    thanks: "Thanks,",
  },
} as const;
